import React, { Component } from "react";
import axios from "axios";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardActionArea,
  TextField,
  Button,
  TablePagination,
} from "@mui/material";
import Serverurl from "./Apiurl";

class QuoteSelectorPanel extends Component {
  state = { open: false,type: null,customers: [],products: [],terms: [],otherCharges: [],page: 0,rowsPerPage: 5,totalItems: 0,search: "",tc_type: 1,
  };

  
  openPanel = (type) => {
    this.setState({ open: true, type, page: 0, search: "" }, () => {
      if (type === "customer") this.fetchCustomers();
      if (type === "product") this.fetchProducts();
      if (type === "terms") this.fetchTerms();
      if (type === "othercharges") this.fetchOtherCharges();
    });
  };

  closePanel = () => {
    this.setState({ open: false, type: null });
  };

  

  fetchCustomers = () => {
    axios
      .get(
        Serverurl +
          "ajaxcustomer.php?action=getall&StartIndex=" +
          this.state.page +
          "&PageSize=" +
          this.state.rowsPerPage +
          "&cu_name=" +
          this.state.search
      )
      .then((res) => {
        this.setState({
          customers: res.data || [],
          totalItems: parseInt(res.data?.[0]?.total || 0),
        });
      });
  };

  fetchProducts = () => {
    axios
      .get(
        Serverurl +
          "ajaxproduct.php?action=getall&StartIndex=" +
          this.state.page +
          "&PageSize=" +
          this.state.rowsPerPage +
          "&pr_name=" +
          this.state.search
      )
      .then((res) => {
        this.setState({
          products: res.data || [],
          totalItems: parseInt(res.data?.[0]?.total || 0),
        });
      });
  };

  fetchTerms = () => {
    axios
      .get(
        Serverurl +
          "ajaxtermsconditions.php?action=getall&StartIndex=" +
          this.state.page +
          "&PageSize=" +
          this.state.rowsPerPage +
          "&tc_type=" +
          this.state.tc_type
      )
      .then((res) => {
        this.setState({
          terms: res.data || [],
          totalItems: parseInt(res.data?.[0]?.total || 0),
        });
      });
  };

  fetchOtherCharges = () => {
    axios
      .get(
        Serverurl +
          "ajaxothercharges.php?action=getall&StartIndex=" +
          this.state.page +
          "&PageSize=" +
          this.state.rowsPerPage +
          "&otc_title=" +
          this.state.search
      )
      .then((res) => {
        this.setState({
          otherCharges: res.data || [],
          totalItems: parseInt(res.data?.[0]?.total || 0),
        });
      });
  };

  /*  RENDER LISTS */

  renderCustomers = () =>
    this.state.customers.map((c) => (
      <Card key={c.cu_id} sx={{ mb: 2 }}>
        <CardActionArea
          onClick={() => {
            this.props.onSelectCustomer(c);
            this.closePanel();
          }}
        >
          <CardContent>
            <Typography variant="h6">{c.cu_name}</Typography>
            <Typography>{c.cu_companyname}</Typography>
            <Typography>{c.cu_phoneno}</Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    ));

  renderProducts = () =>
    this.state.products.map((p) => (
      <Card key={p.pr_id} sx={{ mb: 2 }}>
        <CardActionArea
          onClick={() => {
            this.props.onSelectProduct(p);
            this.closePanel();
          }}
        >
          <CardContent>
            <Typography variant="h6">{p.pr_name}</Typography>
            <Typography>₹ {p.pr_price}</Typography>
            <Typography>GST {p.pr_gst}%</Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    ));

  renderTerms = () =>
    this.state.terms.map((t) => (
      <Card key={t.tc_id} sx={{ mb: 2 }}>
        <CardActionArea
          onClick={() => {
            this.props.onSelectTerms(t);
            this.closePanel();
          }}
        >
          <CardContent>
            <Typography variant="h6">{t.tc_title}</Typography>
            <Typography>{t.tc_content}</Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    ));

  renderOtherCharges = () =>
    this.state.otherCharges.map((o) => (
      <Card key={o.otc_id} sx={{ mb: 2 }}>
        <CardActionArea
          onClick={() => {
            this.props.onSelectOtherCharges(o);
            this.closePanel();
          }}
        >
          <CardContent>
            <Typography variant="h6">{o.otc_title}</Typography>
            <Typography>₹ {o.otc_price}</Typography>
            <Typography>GST {o.otc_tax}%</Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    ));

  /*RENDER*/

  render() {
    return (
      <SlidingPane
        isOpen={this.state.open}
        from="right"
        width="600px"
        title={
          this.state.type === "customer"
            ? "Select Customer"
            : this.state.type === "product"
            ? "Select Product"
            : this.state.type === "terms"
            ? "Select Terms"
            : "Select Other Charges"
        }
        onRequestClose={this.closePanel}
      >
        {/* SEARCH */}
        {(this.state.type === "customer" ||
          this.state.type === "product" ||
          this.state.type === "othercharges") && (
          <TextField
            fullWidth
            size="small"
            placeholder="Search..."
            sx={{ mb: 2 }}
            value={this.state.search}
            onChange={(e) =>
              this.setState({ search: e.target.value, page: 0 }, () => {
                if (this.state.type === "customer") this.fetchCustomers();
                if (this.state.type === "product") this.fetchProducts();
                if (this.state.type === "othercharges")
                  this.fetchOtherCharges();
              })
            }
          />
        )}

        {/* ADD NEW OTHER CHARGE */}
        {this.state.type === "othercharges" && (
          <Button
            variant="contained"
            fullWidth
            sx={{ mb: 2 }}
            onClick={() => {
              this.closePanel();
              this.props.onAddNewOtherCharge();
            }}
          >
            + Add New Other Charge
          </Button>
        )}

        {/* LIST */}
        {this.state.type === "customer" && this.renderCustomers()}
        {this.state.type === "product" && this.renderProducts()}
        {this.state.type === "terms" && this.renderTerms()}
        {this.state.type === "othercharges" && this.renderOtherCharges()}

        {/* PAGINATION */}
        <TablePagination
          component="div"
          count={this.state.totalItems}
          page={this.state.page}
          rowsPerPage={this.state.rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
          onPageChange={(e, p) =>
            this.setState({ page: p }, () => {
              if (this.state.type === "customer") this.fetchCustomers();
              if (this.state.type === "product") this.fetchProducts();
              if (this.state.type === "terms") this.fetchTerms();
              if (this.state.type === "othercharges")
                this.fetchOtherCharges();
            })
          }
          onRowsPerPageChange={(e) =>
            this.setState(
              { rowsPerPage: parseInt(e.target.value), page: 0 },
              () => {
                if (this.state.type === "customer") this.fetchCustomers();
                if (this.state.type === "product") this.fetchProducts();
                if (this.state.type === "terms") this.fetchTerms();
                if (this.state.type === "othercharges")
                  this.fetchOtherCharges();
              }
            )
          }
        />
      </SlidingPane>
    );
  }
}

export default QuoteSelectorPanel;
